class FileLoader {
    constructor(fileList, fileTypeExclusionFilter) {
        fileTypeExclusionFilter = fileTypeExclusionFilter || [];

        this.fileList = fileList || [];
        this.loadedJS = {};
        this.loadedCSS = {};
        this.jsList = [];
        this.cssList = [];
        this.callback = null;
        this.syncReadyStatus = 0;
        this.ready = false;
        this.fileList.forEach((url) => {
            let fileType = url.split('.').pop().toLowerCase();

            // check if there is a querystring we need to trim off
            if (fileType !== 'js' && fileType !== 'css' && url.indexOf('?') > -1) {
                const trimmedUrl = url.split('?')[0];
                fileType = trimmedUrl.split('.').pop().toLowerCase();
            }

            if (fileTypeExclusionFilter.indexOf(fileType) === -1) {
                if (fileType === 'js') {
                    this.jsList.push(url);
                } else if (fileType === 'css') {
                    this.cssList.push(url);
                }
            }
        });
        this.onlyCss = (this.jsList.length === 0);
    }
    /**
     * Downloads all files specified when the file loader was created.
     * First downloads CSS- and then JS-files.
     * @param  {function} callback function called after an attempt has been made to download all files.
     */
    load(callback) {
        this.callback = callback;
        if (this.ready || (this.jsList.length + this.cssList.length === 0)) {
            if (typeof this.callback === 'function') {
                this._executeLoadedCallback();
            }
        } else {
            this.syncReadyStatus = 0;
            this.syncReadyStatusCss = 0;
            this._load('CSS');
            this._load('JS');
        }
    }

    _load(type, iteration) {
        let items = [];
        let callFun = null;
        if (type === 'JS') {
            items = this.jsList;
            callFun = () => {
                this._loadJS(items[iteration], () => {
                    this._load(type, iteration + 1);
                });
            };
        } else if (type === 'CSS') {
            items = this.cssList;
            callFun = () => {
                this._loadCSS(items[iteration], () => {
                    this._load(type, iteration + 1);
                });
            };
        }
        if (!iteration) {
            iteration = 0;
        }
        if (items[iteration] && typeof callFun === 'function') {
            callFun();
        }
    }

    _loadCSS(url, callback) {
        const fileRef = document.createElement('link');
        fileRef.setAttribute('rel', 'stylesheet');
        fileRef.setAttribute('type', 'text/css');
        fileRef.setAttribute('href', url);
        if (typeof callback === 'function') {
            fileRef.onreadystatechange = () => {
                // FF does not have readyState
                if (!fileRef.readyState || fileRef.readyState === 'loaded' || fileRef.readyState === 'complete') {
                    this._updateStatus(url, 'CSS');
                    callback();
                }
            };
            fileRef.onload = fileRef.onreadystatechange;
            fileRef.onerror = () => {
                console.debug('Cannot load css file: %s', url);
                document.getElementsByTagName('head')[0].removeChild(fileRef);
                this._updateStatus(url, 'CSS', false);
                callback();
            };
        }
        document.getElementsByTagName('head')[0].appendChild(fileRef);
    }

    _loadJS(url, callback) {
        const fileRef = document.createElement('script');
        fileRef.setAttribute('type', 'text/javascript');
        fileRef.setAttribute('src', url);
        if (typeof callback === 'function') {
            fileRef.onreadystatechange = () => {
                // FF does not have readyState
                if (!fileRef.readyState || fileRef.readyState === 'loaded' || fileRef.readyState === 'complete') {
                    this._updateStatus(url, 'JS');
                    callback();
                }
            };
            fileRef.onload = fileRef.onreadystatechange;
            fileRef.onerror = () => {
                console.debug('Cannot load js file: %s', url);
                document.getElementsByTagName('head')[0].removeChild(fileRef);
                this._updateStatus(url, 'JS', false);
                callback();
            };
        }
        document.getElementsByTagName('head')[0].appendChild(fileRef);
    }

    _updateStatus(url, fileType, success) {
        success = success !== false;
        this[`loaded${fileType}`][url] = success;
        if (fileType !== 'CSS') {
            this.syncReadyStatus += 1;
            if (this.syncReadyStatus === this.jsList.length) {
                this.ready = true;
                this._executeLoadedCallback();
            }
        } else {
            this.syncReadyStatusCss += 1;
            if (this.syncReadyStatusCss === this.cssList.length && this.onlyCss) {
                this.ready = true;
                this._executeLoadedCallback();
            }
        }
    }

    _executeLoadedCallback() {
        if (typeof this.callback === 'function') {
            this.callback(Object.assign({}, this.loadedJS, this.loadedCSS));
            this.callback = null;
        }
    }
}

/**
 * Downloads the files provided in the fileList parameter except for those that match the filetype in the given
 * exclusion filter
 * @param  {Array.<string>} fileList - A list of all files that can be downloaded
 * @param  {function} fileTypeExclusionFilter - Function used to filter out filetypes that should not be downloaded
 * @returns {Promise} - Resolves with an object where the keys are the files and the value shows if they were succesfully downloaded
 */
function loadFiles(fileList, fileTypeExclusionFilter) {
    return new Promise((resolve) => {
        new FileLoader(fileList, fileTypeExclusionFilter).load((loadedFileList) => {
            resolve(loadedFileList);
        });
    });
}

export default loadFiles;



// WEBPACK FOOTER //
// ../loader-base/src/helpers/file-loader.js